module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-horizontal-de427bcef137da5d81c08197fc2b8d24.svg";